module.exports = __webpack_public_path__ + "img/main-h5.4af13ac7.png";